import TenureInsights from './components/TenureInsights/TenureInsights';
import Overview from './components/Overview/Overview';
import PositionInsights from './components/PositionInsights/PositionInsights';
import {
  position_status,
  // sp_without_successor,
  succession_planning_overview,
  // successor_approaching,
  // successor_status,
  talent_overview,
  // top_talent_categorisation,
  // year_of_position,
  years_in_business_unit,
  years_in_position,
  years_in_salary_grade,
} from '../../assets/img';

export const TA_PATH = '/talent-analytics';
export const TA_DETAIL_PATH = '/talent-analytics-details';

export const TA_TABS = [
  {
    key: 0,
    label: 'Overview',
    path: 'sp-overview',
    component: Overview,
  },
  {
    key: 1,
    label: 'Position Insights',
    path: 'position-insights',
    component: PositionInsights,
  },
  {
    key: 2,
    label: 'Tenure Insights',
    path: 'tenure-insights',
    component: TenureInsights,
  },
];

export const TA_TENURE_TABS = ['Year in Salary Grade', 'Year in Position', 'Year in Business Unit'];
// export const TA_TENURE_TABS = [
//   'Year in Salary Grade',
//   'Year in Position',
//   'Year in Business Unit',
//   'Top Talent Category Dynamics: Transitions and Attrition',
//   'Successors Approaching Retirement Date',
//   'Successor Status',
// ];

export const TYPES_HAVE_RANGES = [TA_TENURE_TABS[0], TA_TENURE_TABS[1]];

export const TA_YEARS_OPTIONS = [
  {
    label: 'Select All',
    value: '0',
    startEndYear: {
      startYear: '0',
      endYear: null,
    },
  },
  {
    label: 'Below 1 Year',
    value: '1',
    startEndYear: {
      startYear: '0',
      endYear: '1',
    },
  },
  {
    label: '1-2 Years',
    value: '2',
    startEndYear: {
      startYear: '1',
      endYear: '2',
    },
  },
  {
    label: '2-3 Years',
    value: '3',
    startEndYear: {
      startYear: '2',
      endYear: '3',
    },
  },
  {
    label: '3-4 Years',
    value: '4',
    startEndYear: {
      startYear: '3',
      endYear: '4',
    },
  },
  {
    label: '4-5 Years',
    value: '5',
    startEndYear: {
      startYear: '4',
      endYear: '5',
    },
  },
  {
    label: '5 Years & Above',
    value: '6',
    startEndYear: {
      startYear: '5',
      endYear: null,
    },
  },
];

export const OVERVIEW_TABS = ['Succession Planning Overview', 'Talent Overview'];
export const POSITION_INSIGHTS_TAB = ['Position Status'];
// export const POSITION_INSIGHTS_TAB = ['SP without Successor', 'Position Status', ' Years of Position'];

export const TI_REPORT_COLUMNS = [
  {
    title: 'No.',
    align: 'left',
    dataIndex: 'no',
  },
  {
    title: 'Name',
    align: 'left',
    style: { fontWeight: 700, color: '#00A19C' },
    dataIndex: 'name',
  },
  {
    title: 'Staff ID',
    dataIndex: 'staff_id',
  },
  {
    title: 'Years in Salary Grade',
    dataIndex: 'years_in_salary_grade',
    reportTypeShow: [TA_TENURE_TABS[0]],
  },
  {
    title: 'Years in Position',
    dataIndex: 'years_in_position',
    reportTypeShow: [TA_TENURE_TABS[1]],
  },
  {
    title: 'Years in Business',
    dataIndex: 'years_in_business',
    reportTypeShow: [TA_TENURE_TABS[2]],
  },
  {
    title: 'Role Level',
    dataIndex: 'role_level',
  },
  {
    title: 'Critical Position Category',
    dataIndex: 'critical_position_category',
    reportTypeShow: [TA_TENURE_TABS[1]],
  },
  {
    title: 'Salary Grade',
    dataIndex: 'salary_grade',
    filterShowName: 'salary_grade',
    reportTypeShow: [TA_TENURE_TABS[0]],
  },
  {
    title: 'Age',
    dataIndex: 'age',
    filterShowName: 'age',
  },
  {
    title: 'Gender',
    dataIndex: 'gender',
    filterShowName: 'gender',
  },
  {
    title: 'Nationality',
    dataIndex: 'nationality',
    filterShowName: 'nationality',
  },
  {
    title: 'State of Birth',
    dataIndex: 'state_of_birth',
    filterShowName: 'state_of_birth',
  },
  {
    title: 'Language',
    dataIndex: 'language',
    filterShowName: 'language',
  },
  {
    title: 'Current Business',
    dataIndex: 'current_business',
    filterShowName: 'current_business',
  },
  {
    title: 'Current Sector',
    dataIndex: 'current_sector',
    filterShowName: 'current_business',
  },
  {
    title: 'Current OPU',
    dataIndex: 'current_opu',
    filterShowName: 'current_business',
  },
  {
    title: 'Current Division',
    dataIndex: 'current_division',
    filterShowName: 'current_business',
  },
  {
    title: 'Current Job Family',
    dataIndex: 'current_job_family',
    filterShowName: 'current_functional',
  },
  {
    title: 'Current Sub Job Family',
    dataIndex: 'current_sub_job_family',
    filterShowName: 'current_functional',
  },
  {
    title: 'Current Function',
    dataIndex: 'current_functional',
    filterShowName: 'current_functional',
  },
  {
    title: 'Years to Retire',
    dataIndex: 'years_to_retire',
    filterShowName: 'year_to_retire',
  },
  {
    title: 'Work Location',
    dataIndex: 'work_location',
    filterShowName: 'work_location',
  },
  {
    title: 'Successor',
    dataIndex: 'successor',
    filterShowName: 'successor',
  },
  {
    title: 'Readiness',
    dataIndex: 'readiness',
    filterShowName: 'successor',
  },
  {
    title: 'Top Talent Status',
    dataIndex: 'top_talent_status',
    filterShowName: 'top_talent_status',
  },
];

export const YISG_AGING_REPORT_TYPE = {
  BY_SALARY_GRADE: 'SALARY_GRADE',
  BY_POSITION: 'POSITION',
  BY_BUSINESS_UNIT: 'BUSINESS_UNIT',
  TOP_TALENT_CATEGORY_DYNAMICS: 'TOP_TALENT_CATEGORY_DYNAMICS',
  SUCCESSORS_APPROACHING_RETIREMENT_DATE: 'SUCCESSOR_APPROACHING_RETIREMENT',
  SUCCESSOR_STATUS: 'SUCCESSOR_STATUS',
};

export const TA_YEARS_LABEL = ['Select All', 'Below 1 Year', '1 - 2 Years', '2 - 3 Years', '3 - 4 Years', '4 - 5 Years', '5 Years & Above'];

export const KEY_NAME_POSITION_STATUS = {
  POSITION_APPROVED_SP: 'approved_succession_planning',
  POSITION_IDENTIFIED_SP: 'not_approved_succession_planning',
  POSITION_WITHOUT_SP: 'key_position_without_approved',
  POSITION_WITHOUT_SP_NEW_POSITION: 'new_position',
};

export const POSITION_STATUS_TAB = {
  POSITION_APPROVED_SP: 'Positions With Approved Succession Planning',
  POSITION_WITHOUT_SP: 'Positions Without Succession Planning',
  POSITION_WITHOUT_SP_NEW_POSITION: 'New Positions',
};

export const POSITION_INSIGHTS_REPORT_COLUMNS = [
  {
    title: 'No.',
    align: 'left',
    dataIndex: 'no',
  },
  {
    title: 'Position ID',
    dataIndex: 'position_id',
  },
  {
    title: 'Position Name',
    dataIndex: 'position_name',
    style: { fontWeight: 700, color: '#00A19C' },
  },
  {
    title: 'Current Incumbent',
    dataIndex: 'current_incumbent',
    style: { fontWeight: 700, color: '#00A19C' },
  },
  {
    title: 'Staff ID',
    dataIndex: 'staff_id',
  },
  {
    title: 'Years in Position',
    dataIndex: 'years_in_position',
  },
  {
    title: 'Role Level',
    dataIndex: 'role_level',
  },
  {
    title: 'Critical Position Category',
    dataIndex: 'critical_position_category',
  },
  {
    title: 'Sensitive Positions Level',
    dataIndex: 'sensitive_positions_level',
  },
  {
    title: 'Status',
    dataIndex: 'status',
  },
  {
    title: 'Reviewed Year',
    dataIndex: 'reviewed_year',
    reportTypeShow: [POSITION_INSIGHTS_TAB[0]],
  },
  {
    title: 'Approved Date',
    dataIndex: 'approved_date',
    reportTypeShow: [POSITION_INSIGHTS_TAB[0]],
  },
  {
    title: 'Matching Criteria',
    dataIndex: 'matching_criteria',
    reportTypeShow: [POSITION_INSIGHTS_TAB[0]],
  },

  {
    title: 'Age',
    dataIndex: 'age',
    filterShowName: 'age',
  },
  {
    title: 'Gender',
    dataIndex: 'gender',
    filterShowName: 'gender',
  },
  {
    title: 'Nationality',
    dataIndex: 'nationality',
    filterShowName: 'nationality',
  },
  {
    title: 'State of Birth',
    dataIndex: 'state_of_birth',
    filterShowName: 'state_of_birth',
  },
  {
    title: 'Language',
    dataIndex: 'language',
    filterShowName: 'language',
  },

  {
    title: 'Current Business',
    dataIndex: 'current_business',
    filterShowName: 'current_business',
  },
  {
    title: 'Current Sector',
    dataIndex: 'current_sector',
    filterShowName: 'current_business',
  },
  {
    title: 'Current OPU',
    dataIndex: 'current_opu',
    filterShowName: 'current_business',
  },
  {
    title: 'Current Division',
    dataIndex: 'current_division',
    filterShowName: 'current_business',
  },
  {
    title: 'Current Job Family',
    dataIndex: 'current_job_family',
    filterShowName: 'current_functional',
  },
  {
    title: 'Current Sub Job Family',
    dataIndex: 'current_sub_job_family',
    filterShowName: 'current_functional',
  },
  {
    title: 'Current Function',
    dataIndex: 'current_function',
    filterShowName: 'current_functional',
  },
  {
    title: 'Years to Retire',
    dataIndex: 'years_to_retire',
    filterShowName: 'year_to_retire',
  },
  {
    title: 'Work Location',
    dataIndex: 'work_location',
    filterShowName: 'work_location',
  },
  {
    title: 'Top Talent Status',
    dataIndex: 'top_talent_status',
    filterShowName: 'top_talent_status',
  },
  {
    title: 'Salary Grade',
    dataIndex: 'salary_grade',
    filterShowName: 'salary_grade',
  },
  {
    title: 'Successor',
    dataIndex: 'successor',
    filterShowName: 'successor',
  },
  {
    title: 'Readiness',
    dataIndex: 'readiness',
    filterShowName: 'successor',
  },
];

export const CRITICAL_POSITION_CATERORY = [{ value: 'CCP' }, { value: 'BCP' }, { value: 'OCP' }, { value: 'OP' }];

export const RANGE_YEAR = [
  { value: 0, label: 'Below 1 Year' },
  { value: 1, label: '1-2 Years' },
  { value: 2, label: '2-3 Years' },
  { value: 3, label: '3-4 Years' },
  { value: 4, label: '4-5 Years' },
  { value: 5, label: '5 Years & Above' },
];
export const DEFAULT_CRITICAL_POSITION = [{ value: 'CCP' }, { value: 'BCP' }, { value: 'OCP' }, { value: 'OP' }];
export const DEFAULT_SENSITIVE_POSITION = [{ value: 'High' }, { value: 'Medium' }, { value: 'Low' }, { value: 'No Level' }];

export const TA_DASHBOARD_CATEGORIES = [
  {
    key: 0,
    label: 'Overview',
    path: 'sp-overview',
    children: [
      {
        key: 0,
        label: 'Succession planning overview',
        desc: 'Some explanation regarding the information on this dashboard.',
        image: succession_planning_overview,
      },
      {
        key: 1,
        label: 'Talent overview',
        desc: 'Some explanation regarding the information on this dashboard.',
        image: talent_overview,
      },
    ],
  },
  {
    key: 1,
    label: 'Position Insights',
    path: 'position-insights',
    children: [
      // {
      //   key: 0,
      //   label: 'SP without successor',
      //   desc: 'Some explanation regarding the information on this dashboard.',
      //   image: sp_without_successor,
      // },
      {
        key: 1,
        label: 'position status',
        desc: 'Some explanation regarding the information on this dashboard.',
        image: position_status,
      },
      // {
      //   key: 2,
      //   label: 'Years of Position',
      //   desc: 'Some explanation regarding the information on this dashboard.',
      //   image: year_of_position,
      // },
    ],
  },
  {
    key: 2,
    label: 'Tenure Insights',
    path: 'tenure-insights',
    children: [
      {
        key: 0,
        label: 'Years in Salary Grade',
        desc: 'Some explanation regarding the information on this dashboard.',
        image: years_in_salary_grade,
      },
      {
        key: 1,
        label: 'Years in position',
        desc: 'Some explanation regarding the information on this dashboard.',
        image: years_in_position,
      },
      {
        key: 2,
        label: 'Years In Business Unit',
        desc: 'Some explanation regarding the information on this dashboard.',
        image: years_in_business_unit,
      },
      // {
      //   key: 3,
      //   label: 'Top Talent Categorisation Changes',
      //   desc: 'Some explanation regarding the information on this dashboard.',
      //   image: top_talent_categorisation,
      // },
      // {
      //   key: 4,
      //   label: 'Successors Approaching Retirement Date',
      //   desc: 'Some explanation regarding the information on this dashboard.',
      //   image: successor_approaching,
      // },
      // {
      //   key: 5,
      //   label: 'Successor Status',
      //   desc: 'Some explanation regarding the information on this dashboard.',
      //   image: successor_status,
      // },
    ],
  },
];
